// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3nGRq","label":"Section_label__3YRva","contentWrap":"Section_contentWrap__EVGYw","footer":"Section_footer__299sl","footerInner":"Section_footerInner__2UNQY"};